<div class="big-euro-container"
     [ngClass]="{'small-size':smallSize, 'radio-euro-section': radioBtnCurrency}">
    <div class="symbol">{{symbol}}</div>
    <div class="amount">{{amount}}</div>
    <div class="decimal">{{decimal}}</div>
    @if (suffix) {
    <div class="suffix">{{suffix}}</div>
    }
</div>